import React, { useEffect, useState} from "react";
import InputField from "../Common/InputField";
import SubmitBtn from "../Common/SubmitBtn";
import AssignmentCoverPageDesign from "./AssignmentCoverPageDesign";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Loading from "../Common/Loading";

export default function AssignmentForm() {
  const [downloading, setDownloading] = useState(false);

  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [courseCode, setCourseCode] = useState("");
  const [assignmentType, setAssignmentType] = useState("Assignment");
  const [studentName, setStudentName] = useState("");
  const [roll, setRoll] = useState("");
  const [year, setYear] = useState("");
  const [studnetDept, setStudentDep] = useState("");
  const [term, setTerm] = useState("");
  const [sirName, setSirName] = useState("");
  const [sirRole, setSirRole] = useState("");
  const [sirDept, setSirDept] = useState("");
  const [faculty, setFaculy] = useState("");
 

  return (
    <div className="md:flex gap-4 max-w-screen-lg my-5 mx-auto">
       <div className="border p-2">
          <h2 className="text-3xl mb-4 text-center">
            Assignment/Lab Cover Page Generator
          </h2>
          <div className="w-full">
            <h3 className="font-semibold text-xl mb-2 mt-2">Basic Info</h3>
            <div>
              <p className="mb-1">Type:</p>
              <select
                className="select select-bordered w-full"
                onChange={(e) => setAssignmentType(e.target.value)}
              >
                <option value="Assignment">Assignment</option>
                <option value="Lab">Lab</option>
              </select>
            </div>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={title}
              label="Title"
              setField={setTitle}
            ></InputField>
            <div className="flex gap-2">
              <InputField
                type="text"
                requiredField="true"
                fieldValue={courseCode}
                label="Course Code"
                setField={setCourseCode}
              ></InputField>
              <InputField
                type="text"
                requiredField="true"
                fieldValue={date}
                label="Date"
                setField={setDate}
              ></InputField>
            </div>
            <h3 className="font-semibold text-xl mt-4">Submitted By</h3>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={studentName}
              label="Student Name"
              setField={setStudentName}
            ></InputField>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={studnetDept}
              label="Department"
              setField={setStudentDep}
            ></InputField>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={faculty}
              label="Faculty"
              setField={setFaculy}
            ></InputField>
            <div className="flex gap-2">
              <InputField
                type="text"
                requiredField="true"
                fieldValue={roll}
                label="Roll"
                setField={setRoll}
                className=""
              ></InputField>
              <InputField
                type="text"
                requiredField="true"
                fieldValue={year}
                label="Year"
                setField={setYear}
                className="w-24"
              ></InputField>
              <InputField
                type="text"
                requiredField="true"
                fieldValue={term}
                label="Term"
                setField={setTerm}
                className="w-24"
              ></InputField>
            </div>
            <h3 className="font-semibold text-xl mt-4">Submitted To</h3>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={sirName}
              label="Name"
              setField={setSirName}
            ></InputField>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={sirRole}
              label="Designation"
              setField={setSirRole}
            ></InputField>
            <InputField
              type="text"
              requiredField="true"
              fieldValue={sirDept}
              label="Department"
              setField={setSirDept}
            ></InputField>
            <div className="mx-auto mt-10 w-full text-center">
            
            </div>
          </div>
          
        </div>
        <div>
         <div className="divider">Preview</div>
            <AssignmentCoverPageDesign
              studentName={studentName}
              roll={roll}
              stduentDept={studnetDept}
              year={year}
              term={term}
              title={title}
              assignmentType={assignmentType}
              date={date}
              sirName={sirName}
              sirRole={sirRole}
              sirDept={sirDept}
              courseCode={courseCode}
              faculty={faculty}
            />
          </div>
    </div>
  );
}
